export { type WordGrapheme, wordGraphemeTable } from "#word-grapheme-table";
